import clsx from 'clsx'
import {useIntl} from 'react-intl'

import {KTIcon} from '../../../helpers'
import {ThemeModeType, useThemeMode} from './ThemeModeProvider'

/** Same icons as ThemeModeSwitcher; labels go in `title` since the row is narrow. */
const THEME_MODES: {mode: ThemeModeType; label: string; icon: string}[] = [
  {mode: 'light', label: 'MENU.LIGHT_MODE', icon: 'night-day'},
  {mode: 'dark', label: 'MENU.DARK_MODE', icon: 'moon'},
  {mode: 'system', label: 'MENU.SYSTEM_MODE', icon: 'screen'},
]

type Props = {
  className?: string
}

/**
 * Three-button light / dark / system segment. Used where the dropdown-based
 * ThemeModeSwitcher does not fit (the phone header drawer).
 */
const ThemeModeSegment = ({className}: Props) => {
  const intl = useIntl()
  const {menuMode, updateMode, updateMenuMode} = useThemeMode()

  const switchMode = (mode: ThemeModeType) => {
    updateMenuMode(mode)
    updateMode(mode)
  }

  return (
    <div className={clsx('btn-group', className)} role='group' aria-label='Theme'>
      {THEME_MODES.map(({mode, label, icon}) => {
        const title = intl.formatMessage({id: label})
        return (
          <button
            key={mode}
            type='button'
            className={clsx('btn btn-sm btn-icon w-100', {
              'btn-primary': menuMode === mode,
              'btn-light': menuMode !== mode,
            })}
            title={title}
            aria-label={title}
            aria-pressed={menuMode === mode}
            onClick={() => switchMode(mode)}
          >
            <KTIcon iconName={icon} className='fs-2' />
          </button>
        )
      })}
    </div>
  )
}

export {ThemeModeSegment}
